ko.validation.rules.pattern.message = 'Invalid.';

ko.validation.init({
    registerExtenders: true,
    messagesOnModified: true,
    insertMessages: false,
    parseInputAttributes: true,
    messageTemplate: null
}, true);

function ReportingModel() {
    var self = this;

    self.unsavedChanges = ko.observable(false);

    self.reportId = ko.observable($('#reportId').val() === '' ? null : $('#reportId').val());
    self.reportName = ko.observable($('.report-name').text());
    self.reportNameSaveAs = ko.observable();
    self.reportNameSaveAsMesage = ko.observable();
    self.reportSaved = ko.observable(false);
    self.userReports = ko.observableArray();

    self.search = $('#search');
    self.securityToken = $('#securityToken');
    self.searchForm = $('#searchForm, #newSearchForm');
    self.reportingResults = $('.reporting-results');
    self.reportingDetails = $('.reporting-details');
    self.commercialResults = $('#commercialResults');
    self.commercialReport = $('#commercialReport');
    self.selectReportModal = $('#selectReportModal');
    self.saveReportModal = $('#saveReportModal');
    self.sendReportModal = $('#sendReportModal');
    self.disableButtons = $('.disable-buttons');

    self.hasListings = ko.observable(false);
    self.showNewReportButton = ko.observable(false);
    self.showSelectReportButton = ko.observable(false);
    self.showReportOptions = ko.observable(false);
    self.showAddToReport = ko.observable(false);
    self.showSaveReport = ko.observable(false);
    self.showDeleteReport = ko.observable(false);
    self.showReportNameSaveAsValidation = ko.observable(false);

    self.showReportEmailMoreThan5Items = ko.observable(false);
    self.showReportEmailToValidation = ko.observable(false);
    self.showReportEmailBccValidation = ko.observable(false);
    self.showReportEmailSubjectValidation = ko.observable(false);
    self.showReportEmailMessageValidation = ko.observable(false);

    self.emailTo = ko.observable('').extend({
        email: true,
        required: {
            message: 'Please supply your email address.'
        }
    });
    self.emailBcc = ko.observable('').extend({ email: true });
    self.emailSubject = ko.observable('').extend({
        maxlength: 78,
        required: {
            message: 'Please supply a subject.'
        }
    });
    self.emailMessage = ko.observable('').extend({
        required: {
            message: 'Please supply a message.'
        }
    });
    self.emailOptions = ko.observable('ClientSummary');

    self.showCommercialResults = ko.observable(true);
    self.showCommercialReport = ko.observable(false);

    self.agentSummaryPreviewUrl = ko.observable('#');
    self.clientSummaryPreviewUrl = ko.observable('#');

    var koObservableToUse = null;

    function toggleWaitingOverlay() {
        $('waiting-overlay').toggle();
    }

    function openPreviewWindow() {
        window.open(koObservableToUse(), '_blank');
        return true;
    }

    function setPreviewUrls(reportId) {
        self.agentSummaryPreviewUrl('/PrintToPDF/CommercialAgentSummaryPreview/' + reportId);
        self.clientSummaryPreviewUrl('/PrintToPDF/CommercialClientSummaryPreview/' + reportId);
    }

    function selectReportPost(reportId) {
        self.reportId(reportId);

        $.post('/reporting/select', { reportId: reportId })
            .success(function (data) {
                self.reportName(data.name);
                self.commercialResults.bootstrapTable('refresh');
                self.commercialReport.bootstrapTable('refresh');
                self.searchForm.submit();
                self.selectReportModal.modal('hide');
                self.unsavedChanges(false);
                showHideNewReportButton();
                setPreviewUrls(data.reportId);
            });
    }

    function deleteReportPost(reportId, removeReportId) {
        self.unsavedChanges(false);
        $.post('/reporting/delete', { reportId: reportId })
            .success(function (data) {
                self.showSaveReport(false);
                self.showDeleteReport(false);
                getUserReports();

                if (removeReportId)
                    selectReport(null, true);

                if (self.selectReportModal.hasClass('in') && self.userReports.length === 0) {
                    self.selectReportModal.modal('hide');
                }
                showHideNewReportButton();

                toggleCommercialResults();
                toggleWaitingOverlay();
                self.disableButtons.removeAttr('disabled');
            });
        toggleWaitingOverlay();
        return true;
    }

    function flashMessage(message, type) {
        var flashSlideToggle = function () {
            var $flash = $('#flash');
            if ($flash.length > 0) {
                $flash.slideToggle('highlight', function () {
                    $flash.remove();
                });
            }
        };

        var $flash = $('<div id=\"flash\" style=\"display:none;\">');
        $flash.html(message);
        $flash.toggleClass('flash');
        $flash.toggleClass(type);
        $('body').prepend($flash);
        $flash.slideDown('slow');
        $flash.click(flashSlideToggle);
        setTimeout(flashSlideToggle, 3000);
    }

    function setUnsavedChanges(val) {
        self.unsavedChanges(val);
    }

    function saveReport(asNew, callback) {
        if (!self.showReportNameSaveAsValidation()) {
            self.disableButtons.attr('disabled', 'disabled');
            var listingIds = [];
            var tableRows = self.commercialReport.find('tbody tr td .add-to-report');
            for (var i = 0; i < tableRows.length; i++)
                listingIds.push($(tableRows[i]).data('listingid'));

            var data = {
                reportId: asNew ? null : self.reportId(),
                jsonPersistedListingIds: JSON.stringify(listingIds),
                name: self.reportName()
            };

            $.ajax({
                url: '/reporting/save',
                method: 'POST',
                async: false,
                dataType: 'json',
                data: data,
                success: function (report) {
                    self.reportId(report.reportId);
                    setPreviewUrls(report.reportId);
                    self.disableButtons.removeAttr('disabled');
                    self.saveReportModal.modal('hide');
                    getUserReports();
                    self.unsavedChanges(false);
                    flashMessage("Data saved successfully", "flash-success");
                    if (callback && typeof callback === "function") {
                        callback();
                    }
                }
            });
        }
        return false;
    }

    function confirmUnsavedChangesDiscard(callback) {
        if (self.unsavedChanges()) {
            bootbox.confirm(
                {
                    size: 'large',
                    message: "There are unsaved changes, are you sure you want to proceed?",
                    callback: function (result) {
                        if (result) {
                            callback();
                        }
                    }
            });
        } else {
            callback();
        }
    }

    function toggleCommercialResults() {
        if (!self.showCommercialResults()) {

            toggleWaitingOverlay();

            showHideNewReportButton();
            self.showSelectReportButton(self.userReports().length > 0);
            self.showReportOptions(false);
            self.showAddToReport(false);
            self.showSaveReport(false);
            self.showDeleteReport(false);

            self.search.slideToggle('fast');
            self.reportingResults.slideToggle('slow', function () {
                self.commercialResults.bootstrapTable('refresh');
                self.reportingDetails.slideToggle('slow');
                $(document).scrollTop(0);
                self.showCommercialResults(true);
                self.showCommercialReport(false);
            });

            toggleWaitingOverlay();
        }
    }

    function toggleCommercialReport() {
        if (!self.showCommercialReport()) {

            toggleWaitingOverlay();

            self.showReportOptions(false);
            showHideNewReportButton();
            self.showSelectReportButton(self.userReports().length > 0);
            self.showAddToReport(true);
            self.showSaveReport(true);
            self.showDeleteReport(true);

            self.search.slideToggle('fast');
            self.reportingResults.slideToggle('slow', function () {

                self.commercialReport.bootstrapTable('refresh');
                self.reportingDetails.slideToggle('slow');
                $(document).scrollTop(0);
                self.showCommercialResults(false);
                self.showCommercialReport(true);
            });

            toggleWaitingOverlay();
        }
    }

    function showHideNewReportButton() {
        if (!self.hasListings() && !self.unsavedChanges() && self.reportId() === null) {
            self.showNewReportButton(false);
        } else {
            self.showNewReportButton(true);
        }
    }

    function selectReport(reportId, confirmOveride) {
        if (confirmOveride)
            selectReportPost(reportId);
        else
            confirmUnsavedChangesDiscard(function () { selectReportPost(reportId); });
    }

    function getUserReports() {
        $.get('/reporting/get-reports')
            .success(function (data) {
                self.userReports(data);
                self.showSelectReportButton(data.length > 0);
            });
    }

    function confirmNewReport() {
        if (!self.unsavedChanges()) {
            selectReport(null);
            toggleCommercialResults();
            self.unsavedChanges(false);
        }
        else
            bootbox.confirm("Are you sure you want to create a new report, all unsaved data will be lost?", function (result) {
                if (result) {
                    selectReport(null, true);
                    toggleCommercialResults();
                    self.unsavedChanges(false);
                }
            });
    }

    function validatePropertySummary() {
        if (self.emailOptions() === 'PropertySummary' &&
            self.commercialReport.find('tbody tr td .add-to-report').length > 5)
            self.showReportEmailMoreThan5Items(true);
        else
            self.showReportEmailMoreThan5Items(false);

        return true;
    }

    self.confirmUnsavedChangesSaveAndContinue = function (koObservable) {
        if (koObservable) koObservableToUse = koObservable;
        if (self.unsavedChanges()) {
            bootbox.confirm("There are unsaved changes that you must save before you continue, click ok to save and continue?", function (result) {
                if (result) {
                    self.saveReportModal.modal('show');
                }
            });
        } else {
            openPreviewWindow();
        }
        return true;
    };

    self.hasListingIds = function (value) {
        self.hasListings(value);
        if (self.commercialResults.is(':visible'))
            self.showReportOptions(value);
        else
            self.showReportOptions(false);

        showHideNewReportButton();
    };

    self.selectReportInModal = function () {
        selectReport(this.reportId);
    };

    self.confirmDeleteReport = function () {
        self.deleteReport(this.reportId, false);
    };
    
    self.deleteReport = function (reportId, removeReportId) {
        if (!reportId) reportId = self.reportId();
        self.disableButtons.attr('disabled', 'disabled');
        bootbox.confirm("Are you sure you want to delete this report?", function (result) {
            if (result) {
                deleteReportPost(reportId, removeReportId);
            } else {
                self.disableButtons.removeAttr('disabled');
            }
        });
    };

    self.validateAndSave = function (asNew, callback) {
        var data = {
            reportId: asNew ? null : self.reportId(),
            name: self.reportName()
        };
        $.ajax({
            url: '/reporting/validate',
            method: 'POST',
            async: false,
            dataType: 'json',
            data: data,
            success: function (data) {
                self.showReportNameSaveAsValidation(!data.valid);
                if (!data.valid) {
                    self.reportNameSaveAsMesage(data.message);
                    flashMessage(data.Message, 'flash-error');
                } else {
                    saveReport(asNew, callback);
                }
            }
        });
    };

    self.newReport = function () {
        confirmNewReport();
    };

    self.reportOptions = function () {
        toggleCommercialReport();
    };

    self.addToReport = function () {
        toggleCommercialResults();
        showHideNewReportButton();
    };

    self.emailAgentSummary = function (reportId) {
        self.disableButtons.attr('disabled', 'disabled');
        $.post('/PrintToPDF/QueueCommercialAgentSummary/' + reportId)
            .success(function (data) {
                flashMessage("Your PDF is queued and will be delivered to you shortly.", "flash-success");
                self.disableButtons.removeAttr('disabled');
            });
    };

    self.emailClientSummary = function (reportId) {
        self.disableButtons.attr('disabled', 'disabled');
        $.post('/PrintToPDF/QueueCommercialClientSummary/' + reportId)
            .success(function (data) {
                flashMessage("Your PDF is queued and will be delivered to you shortly.", "flash-success");
                self.disableButtons.removeAttr('disabled');
            });
    };

    self.emailPropertySummary = function (listingId) {
        self.disableButtons.attr('disabled', 'disabled');
        $.post('/PrintToPDF/QueueCommercialPropertySummaryByListingId/' + listingId)
            .success(function (data) {
                flashMessage("Your PDF is queued and will be delivered to you shortly.", "flash-success");
                self.disableButtons.removeAttr('disabled');
            });
    };

    self.reportSummaryClick = function () {
        return validatePropertySummary();
    };

    self.emailReport = function () {
        if (self.unsavedChanges()) {
            bootbox.confirm("There are unsaved changes that you must save before you continue, click ok to save and continue?", function (result) {
                if (result) {
                    self.saveReportModal.modal('show');
                }
            });
        } else {
            validatePropertySummary();
            self.sendReportModal.modal('show');
        }
    };

    self.validateAndSend = function () {
        if (self.emailErrors().length === 0) {
            self.sendReportModal.modal('hide');
            $.post('/PrintToPDF/QueueCommercialEmailRequest', {
                    reportId: self.reportId(),
                    emailType: self.emailOptions(),
                    emailAddress: self.emailTo(),
                    subject: self.emailSubject(),
                    bcc: self.emailBcc(),
                    message: self.emailMessage()
            })
            .success(function (data) {
                flashMessage("Your email request is queued and will be delivered shortly.", "flash-success");
                self.disableButtons.removeAttr('disabled');
            });
        }
        else {
            bootbox.alert({
                message: 'Please check your form and fix any issues.',
                size: 'small'
            });
            self.emailErrors.showAllMessages();
        }
    };

    self.sendCommercialListingReport = function(listingId) {
        $.post('/PrintToPDF/QueueEmailListing/' + listingId)
        .success(function (data) {
            flashMessage("Your email request is queued and will be delivered shortly.", "flash-success");
            self.disableButtons.removeAttr('disabled');
        });
    };

    getUserReports();
    if (self.reportId() !== null)
        setPreviewUrls(self.reportId());
}

function deleteFromReport(el) {
    var rows = el.parents('tbody').children('tr');
    if (rows.length === 1) {
        bootbox.confirm("If you delete this row, you will delete the report Are you sure you want to continue?", function (result) {
            if (result)
                reportingModel.deleteReport();
        });
    } else {
        $.post('/reporting/remove', {
            ListingId: el.data('listingid'),
            ReportId: el.data('reportid')
        })
          .done(function (result) {
              if (!result.message) {
                  reportingModel.unsavedChanges(true);
                  if (el.parents('table').data('delete-row')) {
                      el.parents('tr').remove();
                      //$('#' + el.parents('table').attr('id')).bootstrapTable('refresh');
                  } else {
                      el.html('<svg class="svg svg-icon-heart"><use xlink:href="/public/img/svg/symbol-defs.svg#svg-icon-heart"></use></svg> Add to report');
                      el.addClass('btn-info');
                      el.removeClass('btn-danger saved active');
                      reportingModel.hasListingIds(result.hasListingIds);
                  }
              } else if (result.message === "Authorization has been denied for this request.") {
                  window.location.reload();
              }
          });
    }
}

function addToReport(el) {

    $.post('/reporting/add', {
        ListingId: el.data('listingid'),
        ReportId: reportingModel.reportId()
    })
      .done(function (result) {
          if (!result.message) {
              el.html('<svg class="svg svg-icon-heart"><use xlink:href="/public/img/svg/symbol-defs.svg#svg-icon-heart"></use></svg> In your report');
              el.addClass('btn-danger saved active');
              el.removeClass('btn-info');
              reportingModel.unsavedChanges(true);
              reportingModel.hasListingIds(result.hasListingIds);
          } else if (result.Message === "Authorization has been denied for this request.") {
              window.location.reload();
          }
      });
}

function formatPrice(value, row, index) {
    return "<span>$" + value + "</span>";
}

function formatArea(value, row, index) {
    return "<span>" + value + "</span>";
}

function formatAddToReport(value, row, index) {
    if (row.inReport)
        return '<button type="button" class="add-to-report btn btn-sm btn-danger saved active btn-outline" data-listingid="' + value + '"><svg class="svg svg-icon-heart"><use xlink:href="/public/img/svg/symbol-defs.svg#svg-icon-heart"></use></svg> In your Report</button>';
    else
        return '<button type="button" class="add-to-report btn btn-sm btn-info btn-outline" data-listingid="' + value + '"><svg class="svg svg-icon-heart"><use xlink:href="/public/img/svg/symbol-defs.svg#svg-icon-heart"></use></svg> Add to Report</button>';
}

function formatListingLink(value, row, index) {
    return "<a target='blank' href='/PrintToPDF/CommercialListing/" + row.listingId + "'>" + row.listingId + "</a>";
}

function formatRemoveFromReport(value, row, index) {
    return '<button type="button" class="add-to-report btn btn-sm btn-danger saved active btn-outline" data-listingid="' + value + '"><svg class="svg svg-icon-heart"><use xlink:href="/public/img/svg/symbol-defs.svg#svg-icon-heart"></use></svg> Remove <br/>from Report</button>';
}

function getCommercialColumns(addToReport) {

    var commercialColumns = [
        {
            title: "",
            field: 'listingId',
            align: 'center',
            valign: 'middle',
            formatter: formatAddToReport
        }, {
            title: 'Listing ID',
            field: 'listingId',
            align: 'center',
            valign: 'middle',
            sortable: false,
            formatter: formatListingLink
        }, {
            title: 'First <br/>Listed <br/>Date',
            field: 'firstListedDate',
            align: 'center',
            valign: 'middle',
            sortable: true,
            order: 'desc'
        }, {
            title: 'Heading',
            field: 'heading',
            align: 'center',
            valign: 'middle',
            sortable: false
        }, {
            title: 'Marketing Address',
            field: 'marketingAddress',
            align: 'center',
            valign: 'middle',
            sortable: false
        }, {
            title: 'Region',
            field: 'region',
            align: 'center',
            valign: 'middle',
            sortable: true,
            order: 'asc'
        }, {
            title: 'Suburb',
            field: 'suburb',
            align: 'center',
            valign: 'middle',
            sortable: true,
            order: 'asc'
        }, {
            title: 'Listing Type',
            field: 'listingTypeDescription',
            align: 'center',
            valign: 'middle',
            sortable: true
        }, {
            title: 'Sale Type',
            field: 'saleTypeName',
            align: 'center',
            valign: 'middle',
            sortable: true
        }, {
            title: 'Price',
            field: 'price',
            align: 'center',
            valign: 'middle',
            sortable: true
        }, {
            title: 'Result',
            field: 'salePrice',
            align: 'center',
            valign: 'middle',
            sortable: false
        }, {
            title: 'Status',
            field: 'listingStatus',
            align: 'center',
            valign: 'middle',
            sortable: true
        }, {
            title: 'Agents',
            field: 'agents',
            align: 'center',
            valign: 'middle',
            sortable: false,
            width: 200
        }, {
            title: 'Branch',
            field: 'branchName',
            align: 'center',
            valign: 'middle',
            sortable: true
        }, {
            title: 'Yield',
            field: 'yield',
            valign: 'middle',
            align: 'left',
            sortable: false
        }, {
            title: 'Area',
            field: 'area',
            valign: 'middle',
            align: 'left',
            sortable: false
        }, {
            title: 'Sqm',
            field: 'areaValues',
            valign: 'middle',
            align: 'right',
            sortable: true,
            formatter: formatArea
        }, {
            title: 'Listing Party',
            field: 'listingParty',
            align: 'left',
            valign: 'middle',
            sortable: false
        }];

    if (!addToReport) {
        commercialColumns[0].formatter = formatRemoveFromReport;
    }

    return commercialColumns;
}

var reportingModel = null;

if ($('.reporting-commercial').length > 0) {

    $(document).ready(function () {

        reportingModel = new ReportingModel();
        ko.applyBindings(reportingModel);
        reportingModel.emailErrors = ko.validation.group(reportingModel);

        $('#commercialResults').bootstrapTable({
            columns: getCommercialColumns(true),
            queryParams: function (params) {
                var query = $('#newSearchForm').serialize();
                if (params.search)
                    query += '&search=' + params.search;
                if (params.sort)
                    query += '&sort=' + params.sort;
                query += '&order=' + params.order;
                query += '&limit=' + params.limit;
                query += '&offset=' + params.offset;
                return query;
            },
            onLoadSuccess: function (data) {
                reportingModel.hasListingIds(data.reportResult.hasListingIds);
            },
            "order": [[2, "desc"]]
        });

        $('#commercialReport').bootstrapTable({
            columns: getCommercialColumns(false),
            queryParams: function (params) {
                if (reportingModel.reportId() !== null)
                    return "id=" + reportingModel.reportId();
            },
            onSort: function (name, order) {
                reportingModel.unsavedChanges(true);
            }
        });

        $('#saveReportForm').submit(function () {
            return false;
        });

        var commercialReport = document.getElementById("commercialReport");
        if (commercialReport !== null) {
            dragula([commercialReport.getElementsByTagName('tbody')[0]])
            .on('drop', function (el) {
                reportingModel.unsavedChanges(true);
                //setSelectedCountMessage();
            });
        }

        $('input[type="radio"][name="resultsView"]').on('change', function () {
            $('#reportResults').attr('class', 'table table-striped table-bordered ' + $('input[type="radio"][name="resultsView"]:checked').val());
            $('#commercialViewType').val($('#resultsView:checked').val());
        });

        $('#reportResults').attr('class', 'table table-striped table-bordered ' + $('input[type="radio"][name="resultsView"]:checked').val());

        $(".search-numeric").keydown(function (e) {
            // Allow: backspace, delete, tab, escape, enter and .
            if ($.inArray(e.keyCode, [46, 8, 9, 27, 13, 110, 190]) !== -1 ||
                // Allow: Ctrl+A
                (e.keyCode == 65 && e.ctrlKey === true) ||
                // Allow: Ctrl+C
                (e.keyCode == 67 && e.ctrlKey === true) ||
                // Allow: Ctrl+X
                (e.keyCode == 88 && e.ctrlKey === true) ||
                // Allow: home, end, left, right
                (e.keyCode >= 35 && e.keyCode <= 39)) {
                // let it happen, don't do anything
                return;
            }
            // Ensure that it is a number and stop the keypress
            if ((e.shiftKey || (e.keyCode < 48 || e.keyCode > 57)) && (e.keyCode < 96 || e.keyCode > 105)) {
                e.preventDefault();
            }
        });

        $('#advancedOptionsChoice').on('click', function () {
            if ($(this).hasClass('show')) {
                $(this).removeClass('show');
                $('#advancedOptions').slideUp();
                $(this).text('[+] Show Advanced Options');
            }
            else {
                $(this).addClass('show');
                $('#advancedOptions').slideDown();
                $(this).text('[-] Hide Advanced Options');
            }
        });

        $(document).on('click', '.add-to-report', function () {
            var el = $(this);
            if (el.hasClass("saved")) {
                deleteFromReport(el);
            } else {
                addToReport(el);
            }
        });
    });
}